import { Component, cloneElement } from 'react';
import withQueueModal from '../../../HOCS/withQueueModal';

const QueueButton = withQueueModal(
  class extends Component<any, any> {
    public render() {
      return cloneElement(this.props.component, {
        onClick: () => {
          if (this.props.onClick) {
            this.props.onClick();
          }
          this.props.showQueueModal();
        }
      });
    }
  }
);

export default QueueButton;
